export enum CandidateFilterPropertyKeys {
  FIELD = 'field',
  CONDITION = 'condition',
  VALUE = 'value',
  COMPLETE = 'complete',
}

export type CandidateFilterValuesType = {
  value: string | number | Date | string[];
  node: (props) => JSX.Element;
};

export type GroupedOptionsType = {
  label: string;
  options: CandidateFilterValuesType[];
};

export type CandidateFilterType = {
  field: string;
  condition: string;
  value: string | number | null | string[];
};

export type CandidateFilterStateType = CandidateFilterType & {
  isOpened: boolean;
  position: CandidateFilterPropertyKeys;
  showingDeleteButton?: boolean;
  prevCondition?: string;
  prevValue?: string | number | null | string[];
};

export type CandidateFilter = {
  property: string;
  conditions: CandidateFilterValuesType[];
  values?: CandidateFilterValuesType[];
  isMultipleType?: boolean;
  isDateType?: boolean;
  groupedOptions?: GroupedOptionsType[];
};

export type AutoCompleteOptionType = {
  label: string;
  checked?: boolean;
  children: JSX.Element;
};
